import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';

export default function UniversityCreateEvent() {
  const { token } = useAuth();
  const [form, setForm] = useState({
    title: '', description: '', eventDate: '', location: '', tags: ''
  });
  const [status, setStatus] = useState('');

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const res = await fetch('https://techservicemarket-backend.onrender.com/api/events', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          ...form,
          tags: form.tags.split(',').map(t => t.trim())
        })
      });

      const data = await res.json();
      if (res.ok) {
        setStatus('Event created!');
        setForm({ title: '', description: '', eventDate: '', location: '', tags: '' });
      } else {
        setStatus(data.message || 'Failed to create event');
      }
    } catch (err) {
      console.error(err);
      setStatus('Network error');
    }
  };

  return (
    <div style={{
      maxWidth: '600px',
      margin: '2rem auto',
      padding: '2rem',
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.08)'
    }}>
     <h2 style={{
  textAlign: 'center',
  marginBottom: '2rem',
  fontSize: '1.75rem',
  fontWeight: 'bold'
}}>
  Post a New Event
</h2>

<button
  onClick={() => window.history.back()}
  style={{
    marginBottom: '1rem',
    backgroundColor: '#e5e7eb',
    border: 'none',
    borderRadius: '6px',
    padding: '0.5rem 1rem',
    cursor: 'pointer'
  }}
>
  ← Back to Dashboard
</button>


      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      {['title', 'description', 'eventDate', 'location', 'tags'].map((field) => (
  <div key={field}>
    <label
      htmlFor={field}
      style={{
        fontWeight: 'bold',
        display: 'block',
        marginBottom: '0.25rem',
        textTransform: 'capitalize'
      }}
    >
      {field === 'eventDate' ? 'Event Date & Time' : field}
    </label>

    <input
  id={field}
  name={field}
  type={field === 'eventDate' ? 'datetime-local' : 'text'}
  placeholder={
    field === 'title' ? 'Event title' :
    field === 'description' ? 'Brief event description' :
    field === 'location' ? 'Location of the event' :
    field === 'tags' ? 'Comma-separated tags (e.g. tech, job fair)' :
    ''
  }
  value={form[field]}
  onChange={handleChange}
  required
  style={{
    padding: '0.6rem',
    width: '100%',
    borderRadius: '8px',
    border: '1px solid #d1d5db',
    fontSize: '1rem'
  }}
/>
          </div>
        ))}
       <button
  type="submit"
  style={{
    backgroundColor: '#1d4ed8',
    color: '#ffffff',
    padding: '0.75rem',
    fontSize: '1rem',
    border: 'none',
    borderRadius: '8px',
    fontWeight: '600',
    cursor: 'pointer'
  }}
>
  Post Event
</button>

{status && (
  <p style={{
    marginTop: '1rem',
    color: status.includes('created') ? '#047857' : '#dc2626',
    textAlign: 'center',
    fontWeight: '500'
  }}>
    {status}
  </p>
)}

      </form>
    </div>
  );
}
